<style lang="scss" scoped>
    .form-check-label {
        font-size: 14px;
    }

    .bold-style {
        font-weight: bold;
    }

    .modal-button {
        float: left;
        padding-left: 50px;
        padding-right: 50px;
        margin-left: 15px;
    }

    .modal-header {
        display: flex;
        justify-content: space-between;
    }

    .modal-title {
        border: 0;
        padding: 0;
    }

    .modal-body {
        min-height: 450px;
    }

    #userRegistrationModal .modal-dialog {
        width: 400px;
        padding: 100px 0;
        margin: auto;
    }

    .close {
        background: transparent;
        border: 0;
        color: #00A8E1;

        span {
            font-size: 20px;
        }
    }

    .custom-select {
        padding: 5px 25px 5px 8px;
        color: #387EB9;
        margin-top: -7px;
        border: 1px solid #DDD;
        -moz-appearance:none; /* Firefox */
        -webkit-appearance:none; /* Safari and Chrome */
        -webkit-appearance: none;
        background: url('/.resources/ampleon-theme/img/asc.gif') center right no-repeat;
        width: 54px;
        height: 34px;
        background-size: 25px;

        &::-ms-expand {
            display: none;
        }
    }

    ul input {
        margin-top: 0 !important;
    }

    .form-check-label {
        margin-left: 5px;
    }

    .invalid-feedback {
        color: red;
        margin-left: 12px;
        margin-bottom: 12px;
        text-align: left;
    }
</style>

<style lang="scss">
    // overwrite standard form input
    .vue-treeselect__input {
        border: 0 !important;
        padding: 0 !important;
    }

    // overwrite standard form input
    .vue-treeselect__input:focus {
        border-color: transparent !important;
        box-shadow: 0 0 black !important;
    }

    .vue-treeselect__control, .vue-treeselect__menu {
        border-radius: 0 !important;
    }
</style>

<template>
    <div class="modal fade" id="userRegistrationModal" tabindex="-1" role="dialog"
         aria-labelledby="userRegistrationModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title" id="userRegistrationModalLabel">User modal</h3>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <treeSelect :multiple="true"
                                :options="permissions.userGroups"
                                :disable-branch-nodes="true"
                                placeholder="Select"
                                v-model="permissions.selectedUsers"/>
                </div>
                <div class="modal-footer">
                    <p v-if="validationError" class="invalid-feedback">User must belong to at least one group.</p>
                    <button type="button"
                            data-toggle="modal"
                            :data-target="target"
                            @click="handleSubmit"
                            class="btn btn-primary modal-button">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { APPROVE_USER, FETCH_TASKS } from "@/store/actions.type";
    import "@riophae/vue-treeselect/dist/vue-treeselect.css"
    import TreeSelect from "@riophae/vue-treeselect";

    export default {
        name: "UserRegistrationModal",
        components: { TreeSelect },
        computed: {
            ...mapGetters("myAdmin", ["taskId", "requestor", "refreshModalToggle", "permissions"]),
            target() {
                if (this.permissions && this.permissions.selectedUsers) {
                    return this.permissions.selectedUsers.length === 0 ? '' : '#userRegistrationModal';
                }
                return '#userRegistrationModal'
            }
        },
        watch: {
            refreshModalToggle: function() {
                this.validationError = false;
            }
        },
        data() {
            return {
                isCollapsed: false,
                validationError: false,
                value: null,
                options: []
            };
        },
        methods: {
            dispatch(action, payload) {
                return this.$store.dispatch('myAdmin/' + action, payload);
            },
            handleSubmit() {
                if (this.permissions.selectedUsers.length === 0) {
                    this.validationError = true;
                } else {
                    this.dispatch(APPROVE_USER).then(() => this.dispatch(FETCH_TASKS));
                }
            },
        }
    };
</script>
